<footer class="footer">
  <div class="footer__inner">
    <div class="footer__links">
      <div class="footer__col footer__col--menu">
        <h4>Menu</h4>
        <nav>
          <a routerLink="/">Home</a>
          <a routerLink="/all-products">Shop</a>
          <a routerLink="/where-to-buy">Store Locator</a>
          <a routerLink="/about">About</a>
          <a routerLink="/faq">FAQ</a>
          <a routerLink="/youtube-testimonials">Testimonials</a>
          <a routerLink="/contact">Contact</a>
        </nav>
        <div class="footer__socials">
          <a
            href="https://www.facebook.com/share/19ouyP46fN/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img src="assets/icons/footer-facebook.svg" alt="" width="37" height="37" />
          </a>
          <a
            href="https://www.instagram.com/hubofnaturals?srtk=MTMwb2szcjZ5bHZrYQ=="
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src="assets/icons/footer-instagram.svg" alt="" width="37" height="37" />
          </a>
          <a
            href="https://www.threads.com/@hubofnaturals?igshid=NTc4MTIwNjQ2YQ=="
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Threads"
          >
            <img src="assets/icons/footer-threads.svg" alt="" width="37" height="37" />
          </a>
          <a
            href="https://x.com/hubofnaturals?s=11"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X"
          >
            <img src="assets/icons/footer-x.svg" alt="" width="34" height="34" />
          </a>
          <a
            href="https://www.tiktok.com/@hub.of.naturals?_r=1&_t=ZT-9AZnqm3yqUg"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <img src="assets/icons/footer-tiktok.svg" alt="" width="37" height="37" />
          </a>
        </div>
      </div>
      <div class="footer__col footer__col--info">
        <h4>Information</h4>
        <nav>
          <a href="#returns">Start a Return</a>
          <a routerLink="/faq">Shopping FAQ</a>
          <a href="#terms">Terms &amp; Conditions</a>
          <a href="#privacy">Privacy Policy</a>
          <a href="#referral">Referral Program</a>
          <a routerLink="/where-to-buy">Store Location’s</a>
        </nav>
      </div>
    </div>

    <div class="footer__col footer__col--brand">
      <a routerLink="/" aria-label="Hub of Naturals home">
        <img src="assets/images/logo.png" alt="Hub of Naturals" width="294" height="282" />
      </a>
      <p>HUB OF NATURALS</p>
    </div>

    <div class="footer__col footer__col--news">
      <h4>dont’t Miss Out on the latest</h4>
      <p class="footer__sub">Get notified of new products, limited release and more</p>
      <form class="newsletter" (submit)="onNewsletterSubmit($event)">
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          required
          aria-label="Enter your email"
          [value]="newsletterEmail()"
          (input)="newsletterEmail.set($any($event.target).value)"
        />
        <button type="submit">Submit</button>
      </form>
      <div class="footer__contact">
        <div>
          <h5>Contact</h5>
          <p>
            Email:
            <a href="mailto:info@hubofnaturals.com">info@hubofnaturals.com</a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <p class="footer__copy">© 2026, Hub of Naturals</p>
</footer>
